export function scrollTo(section: HTMLElement) {
  section.scrollIntoView({ behavior: 'smooth' });
}
